/* ============================================================
   PupStyle · Barcode-Kollektion  ·  assets/ps-barcode.js
   - Echter Code-128 (Set B) als SVG (gleiche Tabelle wie die Druckdatei)
   - Hero: Scan-Animation (Laser + tippendes Ergebnis), pausierbar
   - Wort-Finder: Community-Filter
   - Custom-Name: Live-Vorschau (Text, Textil, Aufdruckfarbe)
   - Reveal unterhalb des Folds
   Idempotent, bootet auf DOMContentLoaded + shopify:section:load.
   Kein externes Script, keine Abhängigkeiten.
   ============================================================ */
(function () {
  'use strict';
  if (window.psBarcode) { return; }

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Code 128 B ---------------- */
  var P = ('212222 222122 222221 121223 121322 131222 122213 122312 132212 221213 221312 231212 112232 122132 ' +
    '122231 113222 123122 123221 223211 221132 221231 213212 223112 312131 311222 321122 321221 312212 ' +
    '322112 322211 212123 212321 232121 111323 131123 131321 112313 132113 132311 211313 231113 231311 ' +
    '112133 112331 132131 113123 113321 133121 313121 211331 231131 213113 213311 213131 311123 311321 ' +
    '331121 312113 312311 332111 314111 221411 431111 111224 111422 121124 121421 141122 141221 112214 ' +
    '112412 122114 122411 142112 142211 241211 221114 413111 241112 134111 111242 121142 121241 114212 ' +
    '124112 124211 411212 421112 421211 212141 214121 412121 111143 111341 131141 114113 114311 411113 ' +
    '411311 113141 114131 311141 411131 211412 211214 211232 2331112').split(' ');

  /* Gleiche Normalisierung wie die Druckdatei: Großbuchstaben, Umlaute -> AE/OE/UE, ß -> SS */
  function normalize(str, max) {
    var s = String(str || '').toUpperCase()
      .replace(/Ä/g, 'AE').replace(/Ö/g, 'OE').replace(/Ü/g, 'UE').replace(/ß/g, 'SS')
      .replace(/\s+/g, ' ');
    var clean = s.replace(/[^A-Z0-9 .\-_!&]/g, '');
    if (max) { clean = clean.slice(0, max); }
    return { value: clean, dropped: clean.length < s.slice(0, max || s.length).length };
  }

  function encode(text) {
    var vals = [104], sum = 104, i, c;
    for (i = 0; i < text.length; i++) {
      c = text.charCodeAt(i) - 32;
      if (c < 0 || c > 94) { continue; }
      vals.push(c);
      sum += c * (vals.length - 1);
    }
    vals.push(sum % 103, 106);
    var mods = [];
    for (i = 0; i < vals.length; i++) {
      var p = P[vals[i]];
      for (var j = 0; j < p.length; j++) { mods.push(+p.charAt(j)); }
    }
    return mods;
  }

  /* Zeichnet den Barcode in ein <svg>. ink === 'camo' -> Camouflage-Muster als Füllung */
  /* Balken als Raster (<canvas>, Bildschirmauflösung) – bewusst KEINE Vektordaten im DOM.
     Ein übergebenes <svg class="ps-bc-bars"> wird beim ersten Aufruf durch ein <canvas> ersetzt. */
  function draw(el, text, ink) {
    if (!el) { return; }
    var cv = el.__psBcCv || el;
    if (cv.tagName && cv.tagName.toLowerCase() === 'svg') {
      var n = document.createElement('canvas');
      n.className = cv.getAttribute('class') || 'ps-bc-bars';
      n.setAttribute('aria-hidden', 'true');
      cv.parentNode.replaceChild(n, cv);
      el.__psBcCv = n; cv = n;
    }
    var mods = encode(text || ' '), total = 0, i;
    for (i = 0; i < mods.length; i++) { total += mods[i]; }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.min(MAX_W, Math.max(120, Math.round((cv.clientWidth || 300) * dpr)));
    var h = Math.max(20, Math.round((cv.clientHeight || 56) * dpr));
    cv.width = w; cv.height = h;
    var c = cv.getContext('2d');
    c.clearRect(0, 0, w, h);
    c.fillStyle = ink === 'camo' ? '#7d7d68' : (ink || getComputedStyle(cv).color || '#ffffff');
    var unit = w / total, x = 0;
    for (i = 0; i < mods.length; i++) {
      if (i % 2 === 0) { var x0 = Math.round(x), x1 = Math.round(x + mods[i] * unit); c.fillRect(x0, 0, Math.max(1, x1 - x0), h); }
      x += mods[i] * unit;
    }
  }

  function inkColor(ink) {
    return ink === 'camo' ? '#7d7d68' : ink;
  }

  /* ---------------- Druck-Abbild 1:1 wie make_print.py (komplett lokal im Browser) ----------------
     Geometrie der Druckdatei (px @300 dpi): Breite 2364, Balken 0–866, Name ab 979 mit 475 Tinten-Höhe,
     Breite 92,5 % (zu lang -> bis 70 %, dann kleiner), Abstand Name->PUPSTYLE 65, PUPSTYLE 49 hoch,
     gesperrt von x 889 bis 1474. Schriften = dieselben Dateien wie der Druck (Barlow Condensed Bold, Kanit Medium). */
  var PW = 2364, BAR_H = 866, NAME_TOP = 979, NAME_H = 475, BRAND_GAP = 65, BRAND_H = 49, BRAND_X0 = 889, BRAND_X1 = 1474;
  var assetsReady = null, camoImg = null;
  var MAX_W = 640;   // Bildschirm-Vorschau, bewusst weit unter Druckauflösung (2364 px)

  function loadAssets() {
    if (assetsReady) { return assetsReady; }
    var a = window.psBarcodeAssets || {};
    var jobs = [];
    if (window.FontFace && document.fonts) {
      // Gewicht exakt wie die Schriftdateien (Barlow Condensed Bold 700, Kanit Medium 500) –
      // ohne Angabe würde der Browser 400 annehmen und beim Zeichnen künstlich fetten (Punzen laufen zu).
      [['PS Barcode Canvas', a.name, '700'], ['PS Barcode Canvas Brand', a.brand, '500']].forEach(function (f) {
        if (!f[1]) { return; }
        var ff = new FontFace(f[0], 'url(' + f[1] + ')', { weight: f[2] });
        jobs.push(ff.load().then(function (l) { document.fonts.add(l); }).catch(function () {}));
      });
    }
    if (a.camo) {
      jobs.push(new Promise(function (res) {
        var im = new Image(); im.onload = function () { camoImg = im; res(); }; im.onerror = res; im.src = a.camo;
      }));
    }
    assetsReady = Promise.all(jobs);
    return assetsReady;
  }

  function inkBox(ctx, txt) {
    var m = ctx.measureText(txt);
    return { l: m.actualBoundingBoxLeft, w: m.actualBoundingBoxLeft + m.actualBoundingBoxRight,
             a: m.actualBoundingBoxAscent, h: m.actualBoundingBoxAscent + m.actualBoundingBoxDescent };
  }

  /* Zeichnet das komplette Druckbild (Balken + Name + PUPSTYLE) in ein <canvas>. opts.bars = nur Balken. */
  function drawPrint(canvas, text, ink, opts) {
    if (!canvas || !canvas.getContext) { return; }
    opts = opts || {};
    text = text || ' ';
    var m = document.createElement('canvas').getContext('2d');
    m.font = '700 600px "PS Barcode Canvas"';
    var nb = inkBox(m, text);
    var sq = 0.925, nh = NAME_H, nw = Math.round(nb.w * NAME_H / nb.h * sq);
    if (nw > PW) {
      sq = Math.max(0.70, sq * PW / nw);
      nw = Math.round(nb.w * NAME_H / nb.h * sq);
      if (nw > PW) { nh = Math.round(NAME_H * PW / nw); nw = PW; }
    }
    var brandTop = NAME_TOP + nh + BRAND_GAP;
    var PH = opts.bars ? BAR_H : brandTop + BRAND_H;

    var css = canvas.clientWidth || canvas.parentNode.clientWidth || 300;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cw = Math.min(MAX_W, Math.max(240, Math.round(css * dpr))), s = cw / PW;   // nie druckfähige Auflösung
    canvas.width = cw; canvas.height = Math.round(PH * s);
    canvas.style.aspectRatio = PW + ' / ' + PH;
    var c = canvas.getContext('2d');
    c.setTransform(s, 0, 0, s, 0, 0);
    c.clearRect(0, 0, PW, PH);
    c.fillStyle = '#000';

    // Balken (gleiche Rundung wie die Druckdatei)
    var mods = encode(text), total = 0, i, x = 0;
    for (i = 0; i < mods.length; i++) { total += mods[i]; }
    var unit = PW / total;
    for (i = 0; i < mods.length; i++) {
      if (i % 2 === 0) { var x0 = Math.round(x), x1 = Math.round(x + mods[i] * unit); c.fillRect(x0, 0, x1 - x0, BAR_H); }
      x += mods[i] * unit;
    }

    if (!opts.bars) {
      // Name: Tinten-Box auf nw x nh skalieren, mittig
      c.save();
      c.font = '700 600px "PS Barcode Canvas"';
      c.translate((PW - nw) / 2, NAME_TOP);
      c.scale(nw / nb.w, nh / nb.h);
      c.fillText(text, nb.l, nb.a);
      c.restore();
      // PUPSTYLE: jeder Buchstabe 49 hoch, gleichmäßig gesperrt zwischen 889 und 1474
      c.font = '500 80px "PS Barcode Canvas Brand"';
      var letters = 'PUPSTYLE'.split(''), boxes = letters.map(function (ch) { return inkBox(c, ch); });
      var widths = boxes.map(function (b) { return b.w * BRAND_H / b.h; });
      var sum = widths.reduce(function (p, v) { return p + v; }, 0);
      var gap = (BRAND_X1 - BRAND_X0 - sum) / (letters.length - 1), bx = BRAND_X0;
      letters.forEach(function (ch, k) {
        var b = boxes[k], sc = BRAND_H / b.h;
        c.save(); c.translate(Math.round(bx), brandTop); c.scale(sc, sc); c.fillText(ch, b.l, b.a); c.restore();
        bx += widths[k] + gap;
      });
    }

    // Einfärben: Aufdruckfarbe oder Original-Camouflage
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.globalCompositeOperation = 'source-in';
    if (ink === 'camo' && camoImg) {
      c.drawImage(camoImg, 0, 0, canvas.width, canvas.width * 1568 / PW);
    } else {
      c.fillStyle = inkColor(ink || '#ffffff');
      c.fillRect(0, 0, canvas.width, canvas.height);
    }
    c.globalCompositeOperation = 'source-over';
    var tile = canvas.closest && canvas.closest('.ps-bc-print');
    if (tile) { tile.classList.add('is-canvas'); }
  }

  /* ---------------- Statische Barcodes (Karten, CTA, Schritte) ---------------- */
  function initStatic(root) {
    var list = root.querySelectorAll('svg[data-ps-bc-code]');
    for (var i = 0; i < list.length; i++) {
      var svg = list[i];
      if (svg.getAttribute('data-ps-bc-drawn')) { continue; }
      draw(svg, normalize(svg.getAttribute('data-ps-bc-code'), 40).value, svg.getAttribute('data-ps-bc-ink'));
      svg.setAttribute('data-ps-bc-drawn', '1');
    }
    var cv = [].slice.call(root.querySelectorAll('canvas[data-ps-bc-code]'));
    if (!cv.length) { return; }
    function paintOne(el) {
      if (el.getAttribute('data-ps-bc-drawn')) { return; }
      el.setAttribute('data-ps-bc-drawn', '1');
      loadAssets().then(function () {
        drawPrint(el, normalize(el.getAttribute('data-ps-bc-code'), 16).value.trim(), el.getAttribute('data-ps-bc-ink'));
      });
    }
    // Erst zeichnen, wenn die Kachel in Sichtweite kommt (spart Main-Thread-Zeit beim Laden)
    if ('IntersectionObserver' in window) {
      var lazy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { lazy.unobserve(en.target); paintOne(en.target); } });
      }, { rootMargin: '400px 0px' });
      cv.forEach(function (el) { lazy.observe(el); });
    } else {
      cv.forEach(paintOne);
    }
  }

  /* ---------------- Hero-Scanner ---------------- */
  var HERO_STYLES = [
    { tex: 'black', ink: '#ffffff' },
    { tex: 'white', ink: '#000000' },
    { tex: 'black', ink: '#ff0059' },
    { tex: 'black', ink: '#0d8fd6' },
    { tex: 'white', ink: '#0043ff' },
    { tex: 'black', ink: '#ffeb00' },
    { tex: 'white', ink: '#8000cc' },
    { tex: 'black', ink: '#00ff00' }
  ];

  function initHero(el) {
    if (el.__psBc) { return; }
    el.__psBc = true;
    var words = (el.getAttribute('data-words') || 'PUPPY').split(',')
      .map(function (w) { return normalize(w, 16).value.trim(); })
      .filter(function (w) { return w.length; });
    if (!words.length) { words = ['PUPPY']; }

    var print = el.querySelector('.ps-bc-print');
    var svg = el.querySelector('.ps-bc-bars');
    var out = el.querySelector('[data-ps-bc-typed]');
    var btn = el.querySelector('.ps-bc-scan__pause');
    var idx = 0, timers = [], paused = false, visible = true, running = false;

    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    function clear() { while (timers.length) { clearTimeout(timers.pop()); } }

    function paint(i) {
      var st = HERO_STYLES[i % HERO_STYLES.length];
      print.setAttribute('data-tex', st.tex);
      print.style.setProperty('--ink', st.ink);
      draw(svg, words[i]);
    }

    function step() {
      if (paused || !visible) { running = false; return; }
      running = true;
      var word = words[idx];
      el.classList.remove('is-found', 'is-scanning');
      el.classList.add('is-swapping');
      out.textContent = '';
      later(function () {
        paint(idx);
        el.classList.remove('is-swapping');
        if (REDUCE) {
          out.textContent = word;
          el.classList.add('is-found');
          later(next, 3200);
          return;
        }
        // Reflow erzwingen, damit die Laser-Animation neu startet
        void el.offsetWidth;
        el.classList.add('is-scanning');
        later(function () {
          el.classList.remove('is-scanning');
          el.classList.add('is-found');
          var n = 0;
          (function type() {
            n++;
            out.textContent = word.slice(0, n);
            if (n < word.length) { later(type, 70); } else { later(next, 1900); }
          })();
        }, 1150);
      }, 240);
    }
    function next() { idx = (idx + 1) % words.length; step(); }

    function resume() { if (!running && !paused && visible) { clear(); step(); } }
    function halt(keepWord) {
      clear(); running = false;
      el.classList.remove('is-scanning', 'is-swapping');
      if (keepWord) { out.textContent = words[idx]; el.classList.add('is-found'); }
    }

    if (btn) {
      btn.addEventListener('click', function () {
        paused = !paused;
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? btn.getAttribute('data-label-play') : btn.getAttribute('data-label-pause'));
        if (paused) { halt(true); } else { resume(); }
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) { resume(); } else { halt(true); }
      }, { threshold: 0.2 }).observe(el);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { halt(true); } else { resume(); }
    });

    // Erster Zustand ist serverseitig vorgerendert (Wort steht schon da) -> kurz halten, dann loslegen
    paint(0);
    out.textContent = words[0];
    el.classList.add('is-found');
    later(next, REDUCE ? 3200 : 1600);
  }

  /* ---------------- Wort-Finder-Filter ---------------- */
  function initFinder(el) {
    if (el.__psBc) { return; }
    el.__psBc = true;
    var bar = el.querySelector('.ps-bc-filter');
    var cards = [].slice.call(el.querySelectorAll('[data-ps-bc-cats]'));
    var status = el.querySelector('[data-ps-bc-status]');
    if (!bar || !cards.length) { return; }
    bar.hidden = false;
    var chips = [].slice.call(bar.querySelectorAll('[data-filter]'));

    // Anzahl je Filter
    chips.forEach(function (chip) {
      var f = chip.getAttribute('data-filter');
      var n = cards.filter(function (c) { return match(c, f) && c.getAttribute('data-ps-bc-cats') !== 'always'; }).length;
      var badge = chip.querySelector('.ps-bc-chip__n');
      if (badge) { badge.textContent = n; }
      if (!n && f !== 'all') { chip.hidden = true; }
    });

    function match(card, f) {
      var cats = ' ' + card.getAttribute('data-ps-bc-cats') + ' ';
      return f === 'all' || cats.indexOf(' always ') > -1 || cats.indexOf(' ' + f + ' ') > -1;
    }

    // Mobil: erst 8 Wörter, Rest per Button (CSS greift nur auf kleinen Screens)
    var grid = el.querySelector('.ps-bc-grid');
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'ps-bc-more';
    more.textContent = (el.getAttribute('data-more-label') || 'Alle [n] Codes anzeigen')
      .replace('[n]', cards.filter(function (c) { return c.getAttribute('data-ps-bc-cats') !== 'always'; }).length);
    function expand() { grid.classList.remove('is-collapsed'); more.hidden = true; }
    if (grid && cards.length > 8) {
      grid.classList.add('is-collapsed');
      grid.parentNode.insertBefore(more, grid.nextSibling);
      more.addEventListener('click', expand);
    }

    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter]');
      if (!chip) { return; }
      var f = chip.getAttribute('data-filter');
      if (f !== 'all') { expand(); }
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      var shown = [], words = 0;
      cards.forEach(function (card) {
        var ok = match(card, f);
        card.hidden = !ok;
        if (ok) {
          shown.push(card);
          if (card.getAttribute('data-ps-bc-cats') !== 'always') { words++; }
        }
      });
      if (!REDUCE) {
        shown.forEach(function (card, i) {
          card.classList.add('is-pre');
          card.style.transitionDelay = Math.min(i, 8) * 35 + 'ms';
        });
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            shown.forEach(function (card) { card.classList.remove('is-pre'); });
            setTimeout(function () { shown.forEach(function (card) { card.style.transitionDelay = ''; }); }, 700);
          });
        });
      }
      if (status) {
        var tpl = status.getAttribute(words === 1 ? 'data-one' : 'data-many') || '[n]';
        status.textContent = tpl.replace('[n]', words);
      }
    });
  }

  /* ---------------- Custom-Name Live-Vorschau ---------------- */
  /* ---------------- Custom-Name-Werbung: selbstlaufende Demo ---------------- */
  var DEMO_STYLES = [
    { tex: 'black', ink: '#ffffff' }, { tex: 'white', ink: '#000000' }, { tex: 'black', ink: '#ff0059' },
    { tex: 'black', ink: 'camo' }, { tex: 'white', ink: '#0043ff' }, { tex: 'black', ink: '#ffeb00' }
  ];
  function initDemo(el) {
    if (el.__psBc) { return; }
    el.__psBc = true;
    var names = (el.getAttribute('data-names') || 'REX').split(',')
      .map(function (w) { return normalize(w, 16).value.trim(); }).filter(function (w) { return w.length; });
    var print = el.querySelector('.ps-bc-print'), canvas = print && print.querySelector('canvas');
    var out = el.querySelector('[data-ps-bc-demo-text]');
    if (!names.length || !canvas || !out) { return; }
    var idx = 0, timer = null, visible = true;
    function paint(text, st) {
      print.setAttribute('data-tex', st.tex);
      print.style.setProperty('--ink', inkColor(st.ink));
      drawPrint(canvas, text, st.ink);
    }
    function run() {
      if (!visible) { timer = null; return; }
      var name = names[idx % names.length], st = DEMO_STYLES[idx % DEMO_STYLES.length], n = 0;
      (function type() {
        n++;
        out.textContent = name.slice(0, n);
        paint(name.slice(0, n), st);
        if (n < name.length) { timer = setTimeout(type, 140); }
        else { idx++; timer = setTimeout(run, 2200); }
      })();
    }
    loadAssets().then(function () {
      if (REDUCE) { out.textContent = names[0]; paint(names[0], DEMO_STYLES[0]); return; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          visible = en[0].isIntersecting;
          if (visible && !timer) { run(); }
          if (!visible && timer) { clearTimeout(timer); timer = null; }
        }).observe(el);
      } else { run(); }
    });
  }

  /* ---------------- GymBag-Promo: Kordelfarbe wechselt das Bild ---------------- */
  function initGym(el) {
    if (el.__psBc) { return; }
    el.__psBc = true;
    var img = el.querySelector('[data-ps-bc-gym-img]');
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.ps-bc-gym__cord');
      if (!b || !img) { return; }
      [].forEach.call(el.querySelectorAll('.ps-bc-gym__cord'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      img.srcset = b.getAttribute('data-srcset'); img.src = b.getAttribute('data-src');
    });
  }

  /* ---------------- Produktseite: Aufdruckfarbe zeigt nur das Design ---------------- */
  var INK_HEX = { 'weiß': '#ffffff', 'weiss': '#ffffff', 'schwarz': '#000000', 'rot': '#cc0000', 'pink': '#ff0059', 'gelb': '#ffeb00',
    'aqua': '#0d8fd6', 'grau': '#848484', 'dunkelgrün': '#009925', 'neongrün': '#00ff00', 'lila': '#8000cc', 'kobaltblau': '#0043ff',
    'camouflage': 'camo' };
  function initInkSwatches(box) {
    if (box.__psBcInk) { return; }
    box.__psBcInk = true;
    var word = normalize(box.getAttribute('data-word'), 16).value.trim();
    var picker = document.querySelector('hdt-variant-picker');
    if (!word || !picker) { return; }
    var sets = [].slice.call(picker.querySelectorAll('fieldset'));
    var inkSet = sets.filter(function (f) { return /aufdruck/i.test((f.querySelector('legend') || f).textContent); })[0];
    var texSet = sets.filter(function (f) { return /textil/i.test((f.querySelector('legend') || f).textContent); })[0];
    if (!inkSet) { return; }
    function tex() {
      var r = texSet && texSet.querySelector('input:checked');
      return r && /wei/i.test(r.value) ? 'white' : 'black';
    }
    var tiles = [];
    [].forEach.call(inkSet.querySelectorAll('input[type="radio"]'), function (inp) {
      var lab = picker.querySelector('label[for="' + inp.id + '"]');
      var img = lab && lab.querySelector('img');
      var ink = INK_HEX[String(inp.value).trim().toLowerCase()];
      if (!img || !ink) { return; }
      var tile = document.createElement('span');
      tile.className = 'ps-bc-swatch ps-bc-print ps-bc-print--full';
      tile.style.setProperty('--ink', inkColor(ink));
      var cv = document.createElement('canvas'); cv.className = 'ps-bc-canvas'; cv.setAttribute('aria-hidden', 'true');
      tile.appendChild(cv);
      img.parentNode.insertBefore(tile, img);
      img.style.display = 'none';
      tiles.push({ tile: tile, cv: cv, ink: ink });
    });
    function paint() {
      var t = tex();
      loadAssets().then(function () {
        tiles.forEach(function (x) { x.tile.setAttribute('data-tex', t); drawPrint(x.cv, word, x.ink); });
      });
    }
    paint();
    if (texSet) { texSet.addEventListener('change', function () { setTimeout(paint, 0); }); }
  }

  /* ---------------- Sprung-Menü: aktiven Abschnitt markieren, aktiven Punkt sichtbar halten ---------------- */
  function initNav(nav) {
    if (nav.__psBc) { return; }
    nav.__psBc = true;
    var links = [].slice.call(nav.querySelectorAll('.ps-bc-nav__link'));
    var map = links.map(function (a) {
      var id = (a.getAttribute('href') || '').replace('#', '');
      var el = id && document.getElementById(id);
      return el ? { a: a, el: el } : null;
    }).filter(Boolean);
    var current = null;
    function setActive(a) {
      if (a === current) { return; }
      current = a;
      links.forEach(function (l) { if (l === a) { l.setAttribute('aria-current', 'true'); } else { l.removeAttribute('aria-current'); } });
      var list = nav.querySelector('.ps-bc-nav__list');
      if (a && list && list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: a.offsetLeft - 16, behavior: REDUCE ? 'auto' : 'smooth' });
      }
    }
    var lock = 0, ticking = false;
    function spy() {
      ticking = false;
      if (Date.now() < lock) { return; }
      var best = null, bestTop = -Infinity, line = nav.getBoundingClientRect().bottom + 80;
      map.forEach(function (m) { var t = m.el.getBoundingClientRect().top; if (t <= line && t > bestTop) { best = m; bestTop = t; } });
      setActive(best ? best.a : null);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }, { passive: true });
    spy();
    nav.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.ps-bc-nav__link');
      if (!a) { return; }
      var m = map.filter(function (x) { return x.a === a; })[0];
      if (!m) { return; }
      e.preventDefault();
      var y = m.el.getBoundingClientRect().top + window.pageYOffset;
      /* Header blendet beim Runterscrollen aus → dann nur Platz fürs Menü lassen */
      var hdr = y > window.pageYOffset ? 0 : (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ph-height'), 10) || 72);
      window.scrollTo({ top: y - hdr - nav.offsetHeight - 8, behavior: REDUCE ? 'auto' : 'smooth' });
      setActive(a);
      lock = Date.now() + 900;
      setTimeout(spy, 950);
      if (history.replaceState) { history.replaceState(null, '', a.getAttribute('href')); }
    });
  }

  /* ---------------- Sprung zum Produktraster ---------------- */
  function onShopLink(e) {
    var a = e.target.closest && e.target.closest('[data-ps-bc-shop]');
    if (!a) { return; }
    var target = document.querySelector('.ps-coll[main-content]') || document.querySelector('.hdt-main-collection-content') || document.getElementById('ps-bc-shop');
    if (!target) { return; }
    e.preventDefault();
    var head = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ph-height'), 10) || 72;
    var top = target.getBoundingClientRect().top + window.pageYOffset - head - 12;
    window.scrollTo({ top: top, behavior: REDUCE ? 'auto' : 'smooth' });
  }

  /* ---------------- Reveal ---------------- */
  var io = ('IntersectionObserver' in window) && !REDUCE ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) { return; }
      en.target.classList.add('is-reveal');
      en.target.classList.remove('is-reveal-pre');
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function initReveal(root) {
    if (!io) { return; }
    var list = root.querySelectorAll('[data-ps-bc-reveal]');
    var vh = window.innerHeight || 800;
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      if (n.__psBcR) { continue; }
      n.__psBcR = true;
      // Nur Elemente unterhalb des sichtbaren Bereichs ausblenden -> kein Flackern above the fold
      if (n.getBoundingClientRect().top > vh) {
        n.classList.add('is-reveal-pre');
        io.observe(n);
      }
    }
  }

  /* ---------------- Boot ---------------- */
  function boot(root) {
    root = root || document;
    initStatic(root);
    [].forEach.call(root.querySelectorAll('[data-ps-bc-hero]'), initHero);
    [].forEach.call(root.querySelectorAll('[data-ps-bc-finder]'), initFinder);
    [].forEach.call(root.querySelectorAll('[data-ps-bc-demo]'), initDemo);
    [].forEach.call(root.querySelectorAll('[data-ps-bc-gym]'), initGym);
    [].forEach.call(root.querySelectorAll('[data-ps-bc-box]'), initInkSwatches);
    [].forEach.call(root.querySelectorAll('[data-ps-bc-nav]'), initNav);
    initReveal(root);
  }

  window.psBarcode = { encode: encode, draw: draw, drawPrint: drawPrint, normalize: normalize, boot: boot };
  document.addEventListener('click', onShopLink);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
